import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row, Button } from 'reactstrap';
import EnquiryModal from '../../../common/pages/enquiryModal';
import service1 from "../../../assets/images/OUR SERVICES/1.Tata my bistro.png";
import service2 from "../../../assets/images/OUR SERVICES/2.Nescafe vending machine.png";
import service3 from "../../../assets/images/OUR SERVICES/3.Snacks machine.png";
import service4 from "../../../assets/images/OUR SERVICES/4. Sanitary napkins machine.png";
import service5 from "../../../assets/images/OUR SERVICES/5.tissue paper.png";
import service6 from "../../../assets/images/OUR SERVICES/6. Cleaning Chemicals.png";
import service7 from "../../../assets/images/OUR SERVICES/7.Housekeeping.png";
import service8 from "../../../assets/images/OUR SERVICES/8.Stationary.png";
import service9 from "../../../assets/images/OUR SERVICES/9.Plant on rent.png";
import service10 from "../../../assets/images/OUR SERVICES/2.Corporate_Gifting.png";
import service11 from "../../../assets/images/OUR SERVICES/11.Ready to eat snacks.png";
import service12 from "../../../assets/images/OUR SERVICES/12.Boat accessories.png";

const services = [
    { title: "Tata Coffee Machine", image: service1, description: "Premium Tata coffee vending solutions for workplaces.", link: '/services/tatamachine' },
    { title: "Nescafe Vending Machine", image: service2, description: "Automatic Nescafe coffee vending for offices.", link: '/services/nescafemachine' },
    { title: "Snacks Vending Machine", image: service3, description: "Automated vending solutions for offices and workplaces.", link: '/services/snacksmachine' },
    { title: "Sanitary Pad Vending Machine", image: service4, description: "Hygiene solutions with automated pad dispensers.", link: '/services/sanitorymachine' },
   
    { title: "Tissue Paper", image: service5, description: "High-quality tissue paper supplies for office needs.", link: '/services/tissuepapers' },
    { title: "Cleaning Chemicals", image: service6, description: "Professional cleaning services for office spaces.", link: '/services/cleaningchemicals' },
    { title: "Housekeeping", image: service7, description: "Complete housekeeping services for offices.", link: '/services/housekeeping' },
    { title: "Office Stationary", image: service8, description: "One-stop solution for all office supply needs.", link: '/services/stationary' },
    
    { title: "Plant on Rent", image: service9, description: "Enhance your workspace with affordable plant rental services.", link: '/services/plantOnRent' },
    { title: "Corporate Gifting", image: service10, description: "Custom corporate gifting solutions for employees and clients.", link: '/services/gifting' },
    { title: "Boat Accessories", image: service12, description: "High-quality accessories for boats and watercraft.", link: '/services/boat' },
    { title: "Ready to Eat Snack", image: service11, description: "Delicious and convenient ready-to-eat snack options.", link: '/services/snacks' }
];

const Services = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(null);

    const toggleModal = () => setModal(!modal);

    return (
        <section className="section" style={{ background: "rgb(52, 81, 159)" }} id="services">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10} className="text-center">
                        <h2 className="mb-4" style={{ color: "white" }}>Our Services</h2>
                    </Col>
                </Row>
                <Row>
                    {services.map((service, index) => (
                        <Col md={3} className="mb-4" key={index}>
                            <div
                                className="card service-card shadow-lg bg-white rounded text-center"
                                style={{
                                    height: "320px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    position: "relative",
                                    overflow: "hidden",
                                    transition: "transform 0.2s ease-in-out",
                                    cursor: "pointer",
                                    transform: hoverIndex === index ? "scale(1.05)" : "scale(1)"
                                }}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                                onClick={() => {
                                    navigate(service.link)
                                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                                }}
                                
                            >
                                <div
                                    className="image-container"
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        height: "250px"
                                    }}
                                >
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="card-img-top service-image"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "container",
                                            opacity: hoverIndex === index ? 0.2 : 1,
                                            transition: "opacity 0.3s ease-in-out"
                                        }}
                                    />
                                    {hoverIndex === index && (
                                        <div
                                            className="hover-description"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                color: "black",
                                                textAlign: "center",
                                                fontSize: "18px",
                                                fontWeight: "bold",
                                                width: "80%",
                                                transition: "opacity 0.3s ease-in-out",
                                            }}
                                        >
                                            {service.description}
                                            <br />
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();  
                                                    navigate(service.link);
                                                }}
                                                className="btn btn-primary mt-2"
                                                style={{
                                                    background: "rgb(238, 99, 82)",
                                                    borderRadius: "20px",
                                                    color: "white",
                                                    fontSize: "15px",
                                                    padding: "8px 15px"
                                                }}
                                            >
                                                Know More
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="card-body mb-2">
                                    <h5 className="card-title fw-bold">{service.title}</h5>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <div className="text-center mt-4">
                    <Button className="px-4 py-2 fw-bold" onClick={toggleModal}
                        style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "15px" }}>
                        Enquiry Now
                    </Button>
                </div>
            </Container>
           <EnquiryModal isOpen={modal} toggle={toggleModal}/>
        </section>
    );
};

export default Services;
